import React from "react";
import "./MetaverseHero.css";

export default function MetaverseHero() {
  const counters = [
    {
      value: "12+",
      text: "Years of Experience",
    },
    {
      value: "40+",
      text: "Metaverse Developers",
    },
    {
      value: "100+",
      text: "Projects Delivered",
    },
    {
      value: "97%",
      text: "Success Rate",
    },
  ];

  const Counter = ({ className }) => (
    <div className={`counter ${className}`}>
      {counters.map((item, index) => (
        <div className="count" key={index}>
          <h2>{item.value}</h2>
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div id="metaverse-hero" className="metaversemainclass">
      <div className="left">
        <h1>
          Metaverse Development Company for Scalable Virtual Worlds
        </h1>
        <p>
          Build scalable metaverse platforms with real-time interaction, blockchain ownership, and cross-platform access—engineered for long-term business growth.
        </p>
      </div>
       <Counter className="desktop-counter" />
    </div>
  );
}
